import React, { useEffect, useState } from 'react'
import Layout from '../../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ListShipOwner from '../../../components/ProjectsAndVessels/ShipOwner/list'
import constant from '../../../constant'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_ship_owners, v3_ship_owner_visibility } from '../../../actions/v3/projectAndVessel'
import SearchFilter from '../../../components/ProjectsAndVessels/ShipOwner/searchFilter'
import { replacePageState } from '../../../utils';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit, setLimit] = useState(10)
    const [payload, setPayload] = useState('');

    useEffect(() => {
        v3_ship_owners(currentPage, limit, payload).then((res) => {
            if (res.status) {
                setData(res.result);
                replacePageState(props.history, constant.Authedcomponent.listShipOwnerMasterData.url, {
                    page: currentPage
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, payload])

    const onChangeVisibility = (record) => {
        const newStatus = !record.IS_ACTIVE; // toggle boolean

        v3_ship_owner_visibility(record.ID, newStatus).then((res) => {
            if (res.status) {
                setData(prevState => ({
                    ...prevState,
                    owners: prevState.owners.map(item => {
                        if (item.ID === record.ID) {
                            return {
                                ...item,
                                IS_ACTIVE: newStatus
                            };
                        }
                        return item;
                    })
                }));

                toast.success(res.result.message);
            } else {
                toast.error("Failed to update yard visibility");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("An error occurred while updating yard visibility");
        });
    };



    return (
        <Layout
            title={'Ship Owner List'}
        >
            <SearchFilter
                onSearch={(newPayload) => { setPayload(newPayload) }}
                onReset={() => { setPayload('') }}
            />
            {data && <ListShipOwner
                onChangeVisibility={onChangeVisibility}
                limit={limit}
                data={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
            />}
        </Layout>
    )
}

export default List